import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import validator from 'validator';
import { getCountryList } from "../../../services/CommonService";
import { register, resendEmailCode } from "../../../services/AuthService";
import Utils from "../../../utils";
import {
    CLIENT_LOCAL_STORE,
    COUNTRY_ID,
    PASSWORD_RULES,
    SALT
} from "../../../configs/AppConfig";
import { encryptData } from "../../../utils/crypto";
import { Lang } from "../../../lang";
import Logo from '../../../assets/Images/Docusafe_logo.webp';
import './AuthPages.css';
import { motion } from 'framer-motion';

function Register() {
    const navigate = useNavigate();

    document.title = Lang.sign_up_title;
    document.getElementsByTagName("META")[4].content = Lang.sign_up_meta_desc;
    document.getElementsByTagName("META")[5].content = Lang.sign_up_meta_keyword;

    let passwordRuleList = PASSWORD_RULES;
    const [passwordRules, setPasswordRules] = useState(passwordRuleList);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [country, setCountry] = useState(COUNTRY_ID);
    const [countryList, setCountryList] = useState([]);
    const [isVerify, setIsVerify] = useState(1);
    const [code, setCode] = useState('');
    const [verificationCode, setVerificationCode] = useState(0);
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState({});
    const [isShowPasswordContain, setIsShowPasswordContain] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    let errorsObj = {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        company_name: '',
        confirm_password: '',
        mobile: '',
        country: '',
        code: '',
        isCheck: '',
    };
    const [errors, setErrors] = useState(errorsObj);

    useEffect(() => {
        Utils.getCurrentCountryCode()
            .then(countryCode => {
                getCountryList()
                    .then(response => {
                        let countryList = response.data.data;
                        if (countryCode) {
                            let index = countryList.findIndex(x => x.icon === countryCode);
                            if (index > -1) {
                                setCountry(parseInt(countryList[index]['id']));
                            }
                        }
                        setCountryList(countryList);
                    })
                    .catch(err => {
                    });
            });
    }, []);

    const handleCountry = (e) => {
        setCountry(e.target.value);
    };

    const handlePassword = (e) => {
        let value = e.target.value;
        setPassword(value);
        let passwordRule = [...passwordRuleList];
        const isContainsUppercase = /^(?=.*[A-Z]).*$/;
        const isContainsLowercase = /^(?=.*[a-z]).*$/;
        const isContainsNumber = /^(?=.*[0-9]).*$/;
        const isContainsSymbol = /^(?=.*[~!@#$%^&]).*$/;
        if (value.length > 7) {
            let index = passwordRule.findIndex(x => x.id === 1);
            if (index > -1) {
                passwordRule[index]['active'] = true;
            }
        } else {
            passwordRule[0]['active'] = false;
        }
        if (isContainsUppercase.test(value)) {
            let index = passwordRule.findIndex(x => x.id === 2);
            if (index > -1) {
                passwordRule[index]['active'] = true;
            }
        } else {
            passwordRule[1]['active'] = false;
        }
        if (isContainsLowercase.test(value)) {
            let index = passwordRule.findIndex(x => x.id === 3);
            if (index > -1) {
                passwordRule[index]['active'] = true;
            }
        } else {
            passwordRule[2]['active'] = false;
        }
        if (isContainsNumber.test(value)) {
            let index = passwordRule.findIndex(x => x.id === 4);
            if (index > -1) {
                passwordRule[index]['active'] = true;
            }
        } else {
            passwordRule[3]['active'] = false;
        }
        if (isContainsSymbol.test(value)) {
            let index = passwordRule.findIndex(x => x.id === 5);
            if (index > -1) {
                passwordRule[index]['active'] = true;
            }
        } else {
            passwordRule[4]['active'] = false;
        }

        setPasswordRules(passwordRule);
    };

    function onRegister(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        const isContainsSymbol = /^(?=.*[~!@#$%^&]).*$/;
        const noSpecialChar = /^[^*|":<>[\]{}`\\()';@&$]+$/;
        let passwordRule = [...passwordRules];

        if (!firstName) {
            errorObj.first_name = 'First name is required';
            error = true;
        } else {
            if (!noSpecialChar.test(firstName)) {
                errorObj.first_name = 'Special characters not allowed';
                error = true;
            }
        }
        if (!lastName) {
            errorObj.last_name = 'Last name is required';
            error = true;
        } else {
            if (!noSpecialChar.test(lastName)) {
                errorObj.last_name = 'Special characters not allowed';
                error = true;
            }
        }
        if (companyName && !noSpecialChar.test(companyName)) {
            errorObj.company_name = 'Special characters not allowed';
            error = true;
        }
        if (!email) {
            errorObj.email = 'Email is required';
            error = true;
        } else if (!validator.isEmail(email)) {
            errorObj.email = 'Please enter valid email address';
            error = true;
        }
        if (!password) {
            errorObj.password = 'Password is required';
            error = true;
        } else if (!validator.isStrongPassword(password, {
            minLength: 8,
            minLowercase: 1,
            minUppercase: 1,
            minNumbers: 1,
            minSymbols: 1
        })) {
            error = true;
        } else {
            if (!isContainsSymbol.test(password)) {
                error = true;
            }
        }
        if (!confirmPassword) {
            errorObj.confirm_password = 'Confirm password is required';
            error = true;
        } else if (confirmPassword !== password) {
            errorObj.confirm_password = 'Confirm password does not match';
            error = true;
        }
        if (!country) {
            errorObj.country = 'Country is required';
            error = true;
        }

        if (!isChecked) {
            errorObj.isCheck = "Terms & condition is required";
            error = true;
        }

        setErrors(errorObj);
        setPasswordRules(passwordRule);

        if (error) return;

        setLoading(true);
        let obj = {
            email: email,
            first_name: firstName,
            last_name: lastName,
        };

        resendEmailCode(obj)
            .then(response => {
                setLoading(false);
                setIsVerify(2);
                setVerificationCode(response.data.code);
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                setLoading(false);
            });
    }

    function onVerify(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (!code) {
            errorObj.code = 'Code is required';
            error = true;
        } else if (parseInt(code) !== verificationCode) {
            errorObj.code = 'Code is wrong.';
            error = true;
        }

        setErrors(errorObj);

        if (error) return;

        setLoading(true);
        let obj = {
            first_name: firstName,
            last_name: lastName,
            company_name: companyName,
            email: email,
            password: password,
            mobile: '',
            country_id: country
        };
        register(obj)
            .then(response => {
                setUserData(response.data.data);
                setIsVerify(3);
                setLoading(false);

            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                setLoading(false);
            });
    }

    const onDashboard = (e) => {
        e.preventDefault();
        let encryptedData = encryptData(userData, SALT);
        localStorage.setItem(CLIENT_LOCAL_STORE, encryptedData);
        navigate('/client-portal');
    };

    return (
        <div className="register-container">
            {loading && <div className="page-loading">
                <img src="/images/loader.gif" alt="loader" />
            </div>}
            {/* Logo at the top */}
            <img src={Logo} alt="Logo" className="register-logo" />
            <div className="register-card">
                <h2 className="register-title mb-0">Sign Up</h2>
                {/* Custom Stepper */}
                <div className="stepper">
                    <div className={`step${isVerify === 1 ? ' active' : ''}`}>
                        <span className={`step-circle${isVerify === 1 ? ' active' : ''}`}>1</span>Details
                    </div>
                    <div className="dashed"></div>
                    <div className={`step${isVerify > 1 ? ' active' : ''}`}>
                        <span className={`step-circle${isVerify > 1 ? ' active' : ''}`}>2</span>Email Confirmation
                    </div>
                </div>

                {isVerify === 1 &&
                    <div>
                        <form onSubmit={onRegister}>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="mb-2">
                                        <motion.label className="form-label" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>First name<sup>*</sup></motion.label>
                                        <input type="text" value={firstName} maxLength="50"
                                            onChange={(e) => setFirstName(e.target.value)}
                                            className="form-control" />
                                        {errors.first_name &&
                                            <div className="register-error">{errors.first_name}</div>}
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="mb-2">
                                        <motion.label className="form-label" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>Last name<sup>*</sup></motion.label>
                                        <input type="text" value={lastName} maxLength="50"
                                            onChange={(e) => setLastName(e.target.value)}
                                            className="form-control" />
                                        {errors.last_name &&
                                            <div className="register-error">{errors.last_name}</div>}
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="mb-2">
                                        <motion.label className="form-label" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>Email<sup>*</sup></motion.label>
                                        <input type="text" value={email} maxLength="50"
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="form-control" />
                                        {errors.email && <div className="register-error">{errors.email}</div>}
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="mb-2">
                                        <motion.label className="form-label" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>Country<sup>*</sup></motion.label>
                                        <select value={country} onChange={handleCountry}
                                            className="form-control">
                                            <option value="">Select Country</option>
                                            {countryList.map((item, i) =>
                                                <option value={item.id} key={i}>{item.name}</option>
                                            )}
                                        </select>
                                        {errors.country &&
                                            <div className="register-error">{errors.country}</div>}
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="mb-2">
                                        <motion.label className="form-label" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>Company name</motion.label>
                                        <input type="text" value={companyName} maxLength="50"
                                            onChange={(e) => setCompanyName(e.target.value)}
                                            className="form-control" />
                                        {errors.company_name &&
                                            <div className="register-error">{errors.company_name}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="mb-2">
                                        <motion.label className="form-label" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>Password<sup>*</sup></motion.label>
                                        <input type="password" value={password} maxLength="15"
                                            onChange={handlePassword}
                                            onFocus={(e) => setIsShowPasswordContain(true)}
                                            className="form-control" />
                                        {errors.password &&
                                            <div className="register-error">{errors.password}</div>}
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="mb-2">
                                        <motion.label className="form-label" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>Confirm Password<sup>*</sup></motion.label>
                                        <input type="password" value={confirmPassword} maxLength="15"
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            className="form-control" />
                                        {errors.confirm_password &&
                                            <div className="register-error">{errors.confirm_password}</div>}
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    {isShowPasswordContain === true && (
                                        <div className="password_instruction bg-light border rounded-3 mb-2 px-2 py-2">
                                            <p className="mb-2 text-dark">Password must contain:</p>
                                            <ul>
                                                {passwordRules.map((item, index) => (
                                                    <li key={index} className={`${item.active ? "text-success" : "text-danger"} mb-2`}>
                                                        <i className={`bi ${item.active ? "bi-check-circle-fill" : "bi-x-circle-fill"}`} aria-hidden="true"></i> {item.text}
                                                    </li>
                                                ))}

                                            </ul>
                                        </div>
                                    )}
                                </div>
                                <div className="col-lg-12">
                                    <div className="mb-2">
                                        <input className="h-auto"
                                            type="checkbox" checked={isChecked}
                                            onChange={(e) => setIsChecked(e.target.checked)} />
                                        <span className="ms-2 font_18 text-black">I agree with <NavLink
                                            to={"/terms-condition"} className={'text-decoration-none'}>Terms & Conditions</NavLink> and <NavLink
                                                to={"/privacy-policy"} className={'text-decoration-none'}> Privacy Policy </NavLink>
                                        </span>
                                        {errors.isCheck &&
                                            <div className="register-error">{errors.isCheck}</div>}
                                    </div>
                                </div>
                                <div className="col-lg-12 text-center">
                                    <button type="submit" className="login-btn-page w-100">Next</button>
                                </div>
                                <div className="col-lg-12">
                                    <p className="custom-font mt-3">Already Have an Account? <NavLink to={"/login"} className="register-link">Login Now</NavLink></p>
                                </div>

                            </div>
                        </form>
                    </div>
                }

                {isVerify === 2 &&
                    <div className="text-center">
                        <p className="mb-2">Please verify your email by entering the activation code that has been sent to your email (<a href={`mailto:${email}`}>{email}</a>).</p>
                        <p className="mb-2">If you haven't received this Email within a few minutes, please check your spam folder.</p>
                        <form onSubmit={onVerify}>
                            <div className="mb-2">
                                <motion.label className="form-label mb-2 text-center d-block" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>Please Enter the email verification Code</motion.label>
                                <input type="number" value={code} onChange={(e) => setCode(e.target.value)}
                                    className="form-control w-75 mx-auto" />
                                {errors.code && <div className="register-error">{errors.code}</div>}
                            </div>
                            <button type="submit" className="login-btn-page w-100">Confirm Email</button>
                        </form>
                    </div>
                }

                {isVerify === 3 &&
                    <div className="text-center" style={{ minHeight: '200px' }}>
                        <label className="form-label mb-2 text-center d-block">You have successfully completed the sign up process.</label>
                        <button onClick={onDashboard} type="button" className="login-btn-page w-100 mb-2">Go to Dashboard</button>
                    </div>
                }
            </div>
        </div>
    );
}

export default Register;